<al-freshdesk-help-modal [backdrop]="false" #helpModal>
	<ng-container fdHeaderActions>
		<ng-container *ngIf="isAdminObservable$ | async">
			<button type="button" class="fd-admin-btn" (click)="openAdminPanel()">
        ⚙ Configure Freshdesk
      </button>
		</ng-container>
	</ng-container>
</al-freshdesk-help-modal>

<!-- IMPORTANT: keep admin popup component OUTSIDE the help modal DOM -->
<app-link-edit-support-freshdesk-admin></app-link-edit-support-freshdesk-admin>
